"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "cleanupReference", {
  enumerable: true,
  get: function get() {
    return referenceHelpers.cleanupReference;
  }
});
Object.defineProperty(exports, "getVerses", {
  enumerable: true,
  get: function get() {
    return referenceHelpers.getVerses;
  }
});
Object.defineProperty(exports, "parseReferenceToList", {
  enumerable: true,
  get: function get() {
    return referenceHelpers.parseReferenceToList;
  }
});
exports.referenceHelpers = void 0;

var referenceHelpers = _interopRequireWildcard(require("./helpers/referenceHelpers"));

exports.referenceHelpers = referenceHelpers;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiLi4vc3JjL2luZGV4LmpzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCAqIGFzIHJlZmVyZW5jZUhlbHBlcnMgZnJvbSAnLi9oZWxwZXJzL3JlZmVyZW5jZUhlbHBlcnMnO1xuZXhwb3J0IHsgcmVmZXJlbmNlSGVscGVycyB9O1xuZXhwb3J0IHtcbiAgY2xlYW51cFJlZmVyZW5jZSxcbiAgZ2V0VmVyc2VzLFxuICBwYXJzZVJlZmVyZW5jZVRvTGlzdCxcbiB9IGZyb20gJy4vaGVscGVycy9yZWZlcmVuY2VIZWxwZXJzJyJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEifQ==